import { module } from 'angular';

import { CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE } from './monitorPipelineStage';

('use strict');

export const CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE_MODULE =
  'spinnaker.core.pipeline.stage.monitorPipeline';
export const name = CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE_MODULE; // for backwards compatibility
module(CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE_MODULE, [
  CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE,
]);
